import {
  extendObservable
} from 'mobx';
import {
  setBrightness
} from '../requests/setBrightness';


export default class SettingsStore {
  constructor() {
    extendObservable(this, {
      sleepMode: false,
    });

    this.enableSleepMode = this.enableSleepMode.bind(this);
    this.disableSleepMode = this.disableSleepMode.bind(this);
    this.toggleSleepMode = this.toggleSleepMode.bind(this);
  }

  enableSleepMode() {
    this.sleepMode = true;
    setBrightness('08');
  }

  disableSleepMode() {
    this.sleepMode = false;
    setBrightness('99');
  }

  toggleSleepMode() {
    if(this.sleepMode) {
      this.disableSleepMode();
    } else {
      this.enableSleepMode();
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/SettingsStore.js